import { graphql } from 'react-relay';
import {
	BODIED_EXTENSION_TYPE,
	REGULAR_EXTENSION_TYPE,
} from '@confluence/fabric-extension-lib/entry-points/extensionConstants.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import { getContentConverterVariables } from '@confluence/fabric-extension-queries/entry-points/getContentConverterVariables.ts';

import type {
	useDataMacroBodyContentConverterQuery as useDataMacroBodyContentConverterQuery$data,
	useDataMacroBodyContentConverterQueryVariables as useDataMacroBodyContentConverterQuery$variables,
} from './__types__/useDataMacroBodyContentConverterQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export function useDataMacroBody(
	node: ExtensionHandlerProps['node'],
	contentId: string,
): {
	value?: string | null;
	missing?: boolean;
} {
	'use no memo';
	const bodyContentParam = node.parameters?.macroParams?.__bodyContent;
	const isPlainText = node.type === REGULAR_EXTENSION_TYPE && Boolean(bodyContentParam);
	const isRichTextMacro = node.type === BODIED_EXTENSION_TYPE;
	const contentConverterQueryResult = useQueryInterop<
		useDataMacroBodyContentConverterQuery$data,
		useDataMacroBodyContentConverterQuery$variables
	>(
		graphql`
			query useDataMacroBodyContentConverterQuery(
				$content: String!
				$contentId: ID!
				$from: String!
				$to: String!
				$spaceKeyContext: String = ""
			) {
				contentConverter(
					from: $from
					to: $to
					content: $content
					contentIdContext: $contentId
					spaceKeyContext: $spaceKeyContext
				) {
					value
				}
			}
		`,
		{
			variables: getContentConverterVariables({
				content: node.content,
				contentId,
			}),
			fetchPolicy: 'cache-only',
			skip: !isRichTextMacro,
		},
	);

	if (isRichTextMacro) {
		return contentConverterQueryResult.data
			? { value: contentConverterQueryResult.data.contentConverter?.value }
			: { missing: true };
	}

	if (isPlainText) {
		return { value: (bodyContentParam?.value as string) || '' };
	}

	return { value: '' };
}
